import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";
import { workTypeLabel } from "@/utils/labels";

interface WorkCardProps {
  work: Work;
  compact?: boolean;
}

export default function WorkCard({ work, compact = false }: WorkCardProps) {
  return (
    <Link
      to={`/works/detail/${work.id}`}
      className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors duration-300 hover:border-primary-300"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-primary-900">
        <img
          src={work.cover}
          alt={`${work.title} 海报`}
          title={`${work.title} 翔田千里影视作品海报`}
          className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.05]"
        />
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/5 to-transparent opacity-80"></div>
        <div className="absolute left-3 top-3 flex items-center gap-1.5">
          <span className="rounded-md bg-background-50/90 px-2 py-1 text-[11px] font-medium text-primary-800 backdrop-blur">
            {workTypeLabel(work.type)}
          </span>
          <span className="rounded-md bg-accent-500 px-2 py-1 text-[11px] font-medium text-primary-950">
            {work.roleType}
          </span>
        </div>
        <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2 p-3">
          <span className="text-[11px] tracking-wide text-background-50/80">{work.year}</span>
          <span className="flex items-center gap-1 rounded-md bg-primary-950/50 px-2 py-1 text-[11px] text-background-50/90 backdrop-blur">
            <i className="ri-star-fill text-[10px] text-accent-400" aria-hidden="true"></i>
            {work.rating.toFixed(1)}
          </span>
        </div>
      </div>
      <div className={`flex flex-1 flex-col ${compact ? "p-3" : "p-4"}`}>
        <h3 className="font-heading text-base leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {work.title}
        </h3>
        <p className="mt-1 text-[11px] uppercase tracking-wide text-foreground-400">{work.enTitle}</p>
        <p className="mt-2 text-xs text-foreground-600">
          {work.genre.join(" / ")} · {work.duration}
        </p>
        <p className="mt-2 clamp-2 text-[11px] leading-relaxed text-foreground-500">
          {work.synopsis}
        </p>
        <div className="mt-auto flex items-center justify-between pt-3">
          <span className="text-xs text-foreground-500">饰 {work.role}</span>
          <i
            className="ri-arrow-right-line text-base text-foreground-400 transition-all group-hover:translate-x-1 group-hover:text-accent-600"
            aria-hidden="true"
          ></i>
        </div>
      </div>
    </Link>
  );
}